"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get arrayHasAtLeastOneItem () {
        return arrayHasAtLeastOneItem;
    },
    get arrayHasAtLeastTwoItems () {
        return arrayHasAtLeastTwoItems;
    },
    get arrayHasExactlyOneItem () {
        return arrayHasExactlyOneItem;
    },
    get arrayHasNoItems () {
        return arrayHasNoItems;
    },
    get asyncFilter () {
        return asyncFilter;
    },
    get shuffleArray () {
        return shuffleArray;
    }
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const arrayHasAtLeastOneItem = (array)=>{
    return !!array && array.length > 0;
};
function arrayHasAtLeastTwoItems(array) {
    return !!array && array.length > 1;
}
function arrayHasExactlyOneItem(array) {
    return !!array && array.length === 1;
}
function arrayHasNoItems(array) {
    return !array || array.length === 0;
}
function asyncFilter(arr, predicate) {
    return _async_to_generator(function*() {
        return Promise.all(arr.map(predicate)).then((results)=>arr.filter((_, index)=>Boolean(results[index])));
    })();
}
const shuffleArray = (array)=>{
    const shuffled = [
        ...array
    ];
    for(let i = shuffled.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [
            shuffled[j],
            shuffled[i]
        ];
    }
    return shuffled;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL2FycmF5cy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgYXJyYXlIYXNBdExlYXN0T25lSXRlbSA9IDxUPihcbiAgYXJyYXk6IE1heWJlPEFycmF5PFQ+PiB8IHVuZGVmaW5lZCxcbik6IGFycmF5IGlzIEFycmF5V2l0aEF0TGVhc3RPbmVJdGVtPFQ+ID0+IHtcbiAgcmV0dXJuICEhYXJyYXkgJiYgYXJyYXkubGVuZ3RoID4gMDtcbn07XG5cbmV4cG9ydCBmdW5jdGlvbiBhcnJheUhhc0F0TGVhc3RUd29JdGVtczxUPihcbiAgYXJyYXk6IE1heWJlPEFycmF5PFQ+PiB8IHVuZGVmaW5lZCxcbik6IGFycmF5IGlzIEFycmF5V2l0aEF0TGVhc3RUd29JdGVtczxUPiB7XG4gIHJldHVybiAhIWFycmF5ICYmIGFycmF5Lmxlbmd0aCA+IDE7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBhcnJheUhhc0V4YWN0bHlPbmVJdGVtPFQ+KFxuICBhcnJheTogTWF5YmU8QXJyYXk8VD4+IHwgdW5kZWZpbmVkLFxuKTogYXJyYXkgaXMgQXJyYXlXaXRoRXhhY3RseU9uZUl0ZW08VD4ge1xuICByZXR1cm4gISFhcnJheSAmJiBhcnJheS5sZW5ndGggPT09IDE7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBhcnJheUhhc05vSXRlbXM8VD4oXG4gIGFycmF5OiBNYXliZTxBcnJheTxUPj4gfCB1bmRlZmluZWQsXG4pOiBhcnJheSBpcyBBcnJheVdpdGhOb0l0ZW1zPFQ+IHwgdW5kZWZpbmVkIHwgbnVsbCB7XG4gIHJldHVybiAhYXJyYXkgfHwgYXJyYXkubGVuZ3RoID09PSAwO1xufVxuXG5leHBvcnQgYXN5bmMgZnVuY3Rpb24gYXN5bmNGaWx0ZXI8VD4oXG4gIGFycjogQXJyYXk8VD4sXG4gIHByZWRpY2F0ZTogKHZhbHVlOiBULCBpbmRleDogbnVtYmVyLCBhcnI6IEFycmF5PFQ+KSA9PiBQcm9taXNlPGJvb2xlYW4+LFxuKSB7XG4gIHJldHVybiBQcm9taXNlLmFsbChhcnIubWFwKHByZWRpY2F0ZSkpLnRoZW4ocmVzdWx0cyA9PlxuICAgIGFyci5maWx0ZXIoKF8sIGluZGV4KSA9PiBCb29sZWFuKHJlc3VsdHNbaW5kZXhdKSksXG4gICk7XG59XG5cbi8qKlxuICogUmV0dXJucyBhIGNvcHkgb2YgdGhlIHByb3ZpZGVkIGFycmF5LCBzaHVmZmxlZCB1c2luZyB0aGUgRmlzaGVyLVlhdGVzXG4gKiBhbGdvcml0aG0uXG4gKiBTZWU6IGh0dHBzOi8vZW4ud2lraXBlZGlhLm9yZy93aWtpL0Zpc2hlciVFMiU4MCU5M1lhdGVzX3NodWZmbGVcbiAqL1xuZXhwb3J0IGNvbnN0IHNodWZmbGVBcnJheSA9IChhcnJheTogYW55W10pID0+IHtcbiAgY29uc3Qgc2h1ZmZsZWQgPSBbLi4uYXJyYXldO1xuICBmb3IgKGxldCBpID0gc2h1ZmZsZWQubGVuZ3RoIC0gMTsgaSA+IDA7IGktLSkge1xuICAgIGNvbnN0IGogPSBNYXRoLmZsb29yKE1hdGgucmFuZG9tKCkgKiAoaSArIDEpKTtcbiAgICBbc2h1ZmZsZWRbaV0sIHNodWZmbGVkW2pdXSA9IFtzaHVmZmxlZFtqXSwgc2h1ZmZsZWRbaV1dO1xuICB9XG4gIHJldHVybiBzaHVmZmxlZDtcbn07XG4iXSwibmFtZXMiOlsiYXJyYXlIYXNBdExlYXN0T25lSXRlbSIsImFycmF5SGFzQXRMZWFzdFR3b0l0ZW1zIiwiYXJyYXlIYXNFeGFjdGx5T25lSXRlbSIsImFycmF5SGFzTm9JdGVtcyIsImFzeW5jRmlsdGVyIiwic2h1ZmZsZUFycmF5IiwiYXJyYXkiLCJsZW5ndGgiLCJhcnIiLCJwcmVkaWNhdGUiLCJQcm9taXNlIiwiYWxsIiwibWFwIiwidGhlbiIsInJlc3VsdHMiLCJmaWx0ZXIiLCJfIiwiaW5kZXgiLCJCb29sZWFuIiwic2h1ZmZsZWQiLCJpIiwiaiIsIk1hdGgiLCJmbG9vciIsInJhbmRvbSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7UUFBYUE7ZUFBQUE7O1FBTUdDO2VBQUFBOztRQU1BQztlQUFBQTs7UUFNQUM7ZUFBQUE7O1FBTU1DO2VBQUFBOztRQWNUQztlQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUF0Q04sTUFBTUwseUJBQXlCLENBQ3BDTTtJQUVBLE9BQU8sQ0FBQyxDQUFDQSxTQUFTQSxNQUFNQyxNQUFNLEdBQUc7QUFDbkM7QUFFTyxTQUFTTix3QkFDZEssS0FBa0M7SUFFbEMsT0FBTyxDQUFDLENBQUNBLFNBQVNBLE1BQU1DLE1BQU0sR0FBRztBQUNuQztBQUVPLFNBQVNMLHVCQUNkSSxLQUFrQztJQUVsQyxPQUFPLENBQUMsQ0FBQ0EsU0FBU0EsTUFBTUMsTUFBTSxLQUFLO0FBQ3JDO0FBRU8sU0FBU0osZ0JBQ2RHLEtBQWtDO0lBRWxDLE9BQU8sQ0FBQ0EsU0FBU0EsTUFBTUMsTUFBTSxLQUFLO0FBQ3BDO0FBRU8sU0FBZUgsWUFDcEJJLEdBQWEsRUFDYkMsU0FBdUU7O1FBRXZFLE9BQU9DLFFBQVFDLEdBQUcsQ0FBQ0gsSUFBSUksR0FBRyxDQUFDSCxZQUFZSSxJQUFJLENBQUNDLENBQUFBLFVBQzFDTixJQUFJTyxNQUFNLENBQUMsQ0FBQ0MsR0FBR0MsUUFBVUMsUUFBUUosT0FBTyxDQUFDRyxNQUFNO0lBRW5EOztBQU9PLE1BQU1aLGVBQWUsQ0FBQ0M7SUFDM0IsTUFBTWEsV0FBVztXQUFJYjtLQUFNO0lBQzNCLElBQUssSUFBSWMsSUFBSUQsU0FBU1osTUFBTSxHQUFHLEdBQUdhLElBQUksR0FBR0EsSUFBSztRQUM1QyxNQUFNQyxJQUFJQyxLQUFLQyxLQUFLLENBQUNELEtBQUtFLE1BQU0sS0FBTUosQ0FBQUEsSUFBSSxDQUFBO1FBQzFDLENBQUNELFFBQVEsQ0FBQ0MsRUFBRSxFQUFFRCxRQUFRLENBQUNFLEVBQUUsQ0FBQyxHQUFHO1lBQUNGLFFBQVEsQ0FBQ0UsRUFBRTtZQUFFRixRQUFRLENBQUNDLEVBQUU7U0FBQztJQUN6RDtJQUNBLE9BQU9EO0FBQ1QifQ==